// extracted by mini-css-extract-plugin
export default {"formattedText":"bulletPointsFormatter_formattedText__INQz8","bulletPoint":"bulletPointsFormatter_bulletPoint__GZ1LV"};